export default __webpack_public_path__ + "static/media/Parachute.256.dc35ee5c.png";